import React, { Component } from "react";
import Hero from './../../components/hero';
import { Link } from "react-router-dom";
import  './../../utils/analytics';
import { Colors } from './../../utils/variables';
import SkillsClinicsSection from './../../components/skillsClinicsSection';
import skillsClinicsData from './../../data/skillsClinics.json';

export default class extends Component {
  componentDidMount = ()=>{
    window.scrollTo(0, 0)
  }
  render() {
    return (
		<div className="primary-background" style={{backgroundColor:Colors.primaryDark,backgroundImage:'url("/images/topo-texture.png")'}}>
      <div className="large-padding centered-text">
        <div className="max-width-container" style={{maxWidth:1200,marginTop:80}}>
          <h2 style={{color:'#fff'}}>{'Registration'}</h2>
          <div className="row">
            <div className="small-12 medium-12 tiny-padding">
              <div className="card primary-background" style={{backgroundSize:'cover', backgroundPosition:'center',backgroundImage:'url("/images/about-us-collage-2.jpg")', borderRadius:10, padding:30, marginTop:30}}>
                <div className="small-max-width-container" style={{maxWidth:400}}>
                  {/* Temporary: registration closed — restore <a href="https://square.link/u/yFTLrgqY"> wrapper and Register Now button when open */}
                  <div className="card primary-background" style={{ borderRadius:10, padding:30}}>
                    <img className="full-width" src="./images/free-to-roam.png" alt="" />
                    <h2 className="white" style={{textDecoration:'none'}}>{'Event Registration'}</h2>
                    {/* <h4 className="white" style={{textDecoration:'none'}}>{'August 14th-16th, 2027'}</h4> */}
                    <h4 className="white" style={{textDecoration:'none'}}>{'Summer 2027'}</h4>
                    {/* <div style={{marginBottom:20,backgroundColor:Colors.tertiary, color:Colors.white}} className="button">Register Now</div> */}
                    <p className="white" style={{ marginBottom: 20, fontSize: '1.25rem', fontWeight: 600 }}>{'Coming Soon'}</p>
                    <h6 className="white subheading">{'Space is limited, early registration is recommended'}</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Clinics section - commented out
        <div style={{ marginTop: 80 }}>
          <SkillsClinicsSection data={skillsClinicsData} variant="cards" showSectionHeader={true} />
        </div>
        */}
        {/* Merch section - commented out
        <div className="max-width-container" style={{maxWidth:1200,marginTop:80}}>
          <h2 style={{color:'#fff'}}>{'Merch'}</h2>
          <p className="subheading" style={{color:'#fff'}}>{`Being rad comes with a first step of looking fresh`}</p>
          <a style={{textDecoration:'none'}} target="_blank" href=" https://square.link/u/aFDuVMYh?src=sheet">
            <div className="card primary-background" style={{borderRadius:10, padding:30}}>
              <div className="row">
                <div className="small-12 medium-6">
                  <img className="full-width" src="/images/shirt.jpg" />
                </div>
                <div className="small-12 medium-6 small-padding row" style={{alignItems:'center'}}>
                  <div className="full-width">
                  <h2 className="white" style={{textDecoration:'none'}}>{'Peak Pursuits Tank'}</h2>
                  <div style={{marginBottom:20,backgroundColor:Colors.tertiary, color:Colors.white}} className="button">Buy Now</div>
                  </div>
                </div>
              </div>
            </div>
          </a>

        </div>
        */}
        {/* Stay With Us section - commented out
        <div className="max-width-container" style={{maxWidth:1200,marginTop:80}}>
          <h2 style={{color:'#fff'}}>{'Stay With Us'}</h2>
          <div className="row" style={{alignItems:'stretch'}}>
            <div className="small-12 medium-6 tiny-padding">
              <div className="card primary-background" style={{borderRadius:10, padding:30, height:'100%'}}>
                <h2 className="white" style={{textDecoration:'none'}}>{'Lodging'}</h2>
                <p className="white subheading">{'We encourage you to stay with us at Kirkwood! In order to receive the Peak Pursuits special group rate please call '}<strong>{'(855) 948-0694'}</strong>{'. This is a reservation line dedicated to making reservations for group guests. Guests can call every day from 8am-5pm MT.'}</p>
                <p className="white subheading">{'Please refer to the group code: '}<strong>{'SKWPPB25'}</strong>{' or the group name: '}<strong>{'Peak Pursuits 25'}</strong>{' when making your reservation.'}</p>
                <p className="white subheading">{'The nightly set rates for lodging at the Mountain Club at Kirkwood Mountain Resort for Peak Pursuits participants will be:'}<br/>
                <strong>{'$149'}</strong>{' for a Queen/Queen'}<br/>
                <strong>{'$164'}</strong>{' for a studio'}<br/>
                <strong>{'$179'}</strong>{' for a studio plus loft'}<br/>
                {'(plus taxes and fees)'}</p>
                <div style={{marginTop:20}}>
                  <a style={{textDecoration:'none'}} target="_blank" href="https://www.kirkwood.com/Plan-Your-Trip/stay/details/The-Mountain-Club.aspx?location=50016842">
                    <div style={{backgroundColor:Colors.tertiary, color:Colors.white}} className="button">Book Lodging</div>
                  </a>
                </div>
              </div>
            </div>
            <div className="small-12 medium-6 tiny-padding">
              <div className="card primary-background" style={{borderRadius:10, padding:30, height:'100%'}}>
                <h2 className="white" style={{textDecoration:'none'}}>{'Camping'}</h2>
                <p className="white subheading">{'Camping for Peak Pursuits is first come, first serve.'}</p>
                <p className="white subheading"><strong>{'25 spots available.'}</strong></p>
                <p className="white subheading">{'Reservations are for confirmed paid participants of Free to Roam only.'}</p>
                <p className="white subheading"><strong>{'$75 the weekend, per campsite.'}</strong></p>
                <p className="white subheading">{'Camping is located in the Upper Red Cliffs parking lot at Kirkwood Mountain Resort. Campers must show proof of Peak Pursuits camping registration when checking in.'}</p>
                <p className="white subheading">{'All campers must check-in with a Peak Pursuits representative or designated Kirkwood Staff, prior to selecting a camp site.'}
                {'Camping permits must be displayed in the vehicle at all times.'}</p>
                <div style={{marginTop:10}}>
                  <a style={{textDecoration:'none'}} target="_blank" href="https://square.link/u/JRbwq3dX">
                    <div style={{backgroundColor:Colors.tertiary, color:Colors.white}} className="button">Book Camping</div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        */}
      </div>
    </div>
    );
  }
}
